// extracted by mini-css-extract-plugin
var _1 = "EmailGoogleTemplateModal-modulecontentContainer__ypoPu";
var _2 = "EmailGoogleTemplateModal-modulecontentWrapper___G6uO Content-modulecontentWrapper__p1AMw";
export { _1 as "contentContainer", _2 as "contentWrapper" }
